import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnInit,
} from "@angular/core";
import { ArrowScrollForTablesComponent } from "../arrow-scroll-for-tables/arrow-scroll-for-tables.component";
import { INITIAL_SCHOOLS_TABLE_PAGE_SIZE } from "../../constants";

@Component({
  selector: "school-comp-table",
  templateUrl: "./school-comp-table.component.html",
  styleUrls: ["./school-comp-table.component.scss"],
})
export class SchoolCompTableComponent
  extends ArrowScrollForTablesComponent
  implements OnInit {
  @ViewChild("scPaginator", { static: true }) scPaginator;

  @Input() panels;
  @Input() columns;
  @Input() districtOverall;
  @Input() districtColors;
  @Input() district;
  @Input() schools;
  @Input() sortCol;
  @Input() sortDirection;
  @Input() initialPageNumber;
  @Input() initialPageSize;

  @Output() emitSortColumn = new EventEmitter<any>();
  @Output() emitUpdatePagination = new EventEmitter<any>();

  partialImagePath: string = "../../assets/images/";
  bodyRowHoveredIndex;
  fixedColRowHoveredIndex;
  headerIsStuck: boolean;
  isLongPage: boolean;
  lowerBound: number = 0;
  upperBound: number = INITIAL_SCHOOLS_TABLE_PAGE_SIZE;
  pageSize: number = INITIAL_SCHOOLS_TABLE_PAGE_SIZE;

  protected tableType = "school";

  ngOnInit() {
    this.isLongPage =
      !this.headerIsStuck && this.schools && this.schools.length > 10;
    if (this.initialPageNumber || this.initialPageSize) {
      this.setLowerAndUpperBounds(
        this.initialPageNumber ? this.initialPageNumber : this.lowerBound,
        this.initialPageSize ? this.initialPageSize : this.pageSize
      );
      if (this.initialPageNumber) {
        this.scPaginator.pageIndex = this.initialPageNumber;
      }
      if (this.initialPageSize) {
        this.pageSize = this.initialPageSize;
      }
    }
  }

  sortColumn(colObj) {
    this.emitSortColumn.emit(colObj);
  }

  bodyRowHovered(event) {
    this.bodyRowHoveredIndex = event;
  }

  fixedColRowHovered(event) {
    this.fixedColRowHoveredIndex = event;
  }

  headerStickinessChanged(isStuck) {
    this.headerIsStuck = isStuck;
    this.isLongPage =
      !this.headerIsStuck && this.schools && this.schools.length > 10;
  }

  onPaginate(event) {
    this.setLowerAndUpperBounds(event.pageIndex, event.pageSize);
    this.pageSize = event.pageSize;
    this.emitUpdatePagination.emit(event);
  }

  setLowerAndUpperBounds(pageIndex, pageSize) {
    this.lowerBound = pageIndex * pageSize;
    this.upperBound = this.lowerBound + pageSize;
  }
}
